module.exports = __webpack_public_path__ + "img/how-it-works-7.a5311ea4.svg";